import React from 'react';
import Hero from '../components/Hero';
import RecruitmentBanner from '../components/RecruitmentBanner';
import BusinessSection from '../components/Business';
import NoticeSection from '../components/Notice';
import InfoCards from '../components/InfoCards';
import {
  heroSlides,
  businessServices,
  noticeItems,
  quickMenuItems,
  infoCards,
} from '../data';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero slides={heroSlides} />
      <RecruitmentBanner />
      <main className="main-content">
        <BusinessSection services={businessServices} />
        <NoticeSection noticeItems={noticeItems} quickMenuItems={quickMenuItems} />
        <InfoCards cards={infoCards} />
      </main>
    </>
  );
};

export default HomePage;
